import { DashUserPreferences } from './dash-user-preferences.model';
import { environment } from '../../../../environments/environment';

export class DashUserInfo {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (!environment.isDemoMode)
                this.preferences = json.preferencesJson ? new DashUserPreferences(JSON.parse(json.preferencesJson)) : new DashUserPreferences();
            else {
                // TODO - Spatial Adjust Demo Support. json.preferencesJson will be a string.
                const prefs = (typeof json.preferencesJson === 'string') ? JSON.parse(json.preferencesJson) : json.preferencesJson;
                this.preferences = json.preferencesJson ? new DashUserPreferences(prefs) : new DashUserPreferences();
            }
        }
    }

    id: string;
    email: string;
    preferences: DashUserPreferences;
}
